import React, { useEffect, useState } from 'react';
import { doGetCompanies } from '../../../modules/companies/stores/thunk';
import { AppDispatch, RootState } from '../../../redux/store';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from '../../../components/ui/button';
import { Save } from 'lucide-react';
import { doCreateSetting, doGetSettings, doUpdateSetting } from '../../../modules/settings/store/thunk';
import { selectAllSettings } from '../../../modules/settings/store/slice';

const Invoicing = () => {
  const dispatch = useDispatch<AppDispatch>();
  const companies = useSelector((state: RootState) => state.company.companies).entities;
  const existing = useSelector((state: RootState) => selectAllSettings(state));

  const [invoiceFrequency, setInvoiceFrequency] = useState<Record<string, 'monthly' | 'weekly'>>();

  useEffect(() => {
    dispatch(doGetCompanies({ page: 1, take: 1000 }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(doGetSettings({ category: 'invoicing' }));
  }, []);

  const handleSave = async () => {
    const updates = [];
    Object.entries(invoiceFrequency || {}).forEach(([companyId, value]) => {
      updates.push({
        id: existing.find((e) => e.keyword === 'FREQUENCY' && e.companyId.toString() === companyId)?.id || null,
        keyword: 'FREQUENCY',
        value: value,
        group: 'INVOICING',
        companyId: companyId,
      });
    });

    try {
      await Promise.all(
        updates.map(async (u) => {
          if (u.id && u.value) {
            // if it existed and has a value => update it
            await dispatch(doUpdateSetting(u));
          } else if (u.value) {
            // if it didn't exist => create it
            await dispatch(doCreateSetting(u));
          }
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (existing) {
      const frequencies = existing.reduce((acc, setting) => {
        if (setting.keyword === 'FREQUENCY') {
          return { ...acc, [setting.companyId]: setting.value as 'monthly' | 'weekly' };
        }
        return acc;
      }, {});
      setInvoiceFrequency(frequencies);
    }
  }, [existing]);

  return (
    <div className="m-6">
      <h1 className="text-xl font-bold">Invoicing</h1>
      <div>
        <div>
          {Object.values(companies)?.map((company: { id: string; name: string; debtorId: string }) => (
            <div className="flex items-center justify-between" key={company.id}>
              <div>
                <h2 className="font-semibold">{company.name}</h2>
                <p className="text-sm text-muted-foreground">Debtor ID: {company.debtorId}</p>
              </div>
              <div className="flex items-center gap-2 mt-8">
                <Button
                  variant={'outline'}
                  className={invoiceFrequency?.[company.id] === 'monthly' ? 'border-black' : ''}
                  onClick={() => setInvoiceFrequency({ ...invoiceFrequency, [company.id]: 'monthly' })}
                >
                  Monthly
                </Button>
                <Button
                  variant={'outline'}
                  className={invoiceFrequency?.[company.id] === 'weekly' ? 'border-black' : ''}
                  onClick={() => setInvoiceFrequency({ ...invoiceFrequency, [company.id]: 'weekly' })}
                >
                  Weekly
                </Button>
              </div>
            </div>
          ))}
          <div className="flex justify-end mt-8 gap-4">
            <Button className="px-8" onClick={handleSave}>
              <Save /> Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoicing;
